import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Sorry, this product is not available in your region',
  },
};
